import React from 'react';

export type ErrorsObject = { errors?: { [key: string]: string } };
export const ErrorContext = React.createContext<ErrorsObject>({});
